module.exports = __webpack_public_path__ + "static/media/RoamlyResized.63a84792.png";